module.exports = __webpack_public_path__ + "media/bookly.25e2714a.mp4";